import { Globe, Lock, Search, LucideIcon } from 'lucide-react'
import { Visibility } from '../types/visibility'

export interface VisibilityMeta {
  label: string
  shortLabel: string
  icon: LucideIcon
  // Tailwind classes for the badge (public/private/discoverable)
  badgeClass: string
  iconClass: string
  // Description copy used inside the selector
  description: string
}

export const VISIBILITY_META: Record<Visibility, VisibilityMeta> = {
  public: {
    label: 'Public',
    shortLabel: 'Public',
    icon: Globe,
    badgeClass: 'bg-green-100 text-green-700',
    iconClass: 'text-green-600',
    description: 'Anyone can view this album',
  },
  discoverable: {
    label: 'Discoverable',
    shortLabel: 'Discoverable',
    icon: Search,
    badgeClass: 'bg-amber-100 text-amber-700',
    iconClass: 'text-amber-600',
    description: 'Album listed publicly; contents require a share password',
  },
  private: {
    label: 'Private',
    shortLabel: 'Private',
    icon: Lock,
    badgeClass: 'bg-gray-100 text-gray-700',
    iconClass: 'text-gray-500',
    description: 'Only people with the share link and password',
  },
}

export function visibilityMeta(v: Visibility): VisibilityMeta {
  return VISIBILITY_META[v] ?? VISIBILITY_META.private
}